import { Component, Output, EventEmitter } from '@angular/core';

export type FontSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'app-font-size-picker',
  imports: [],
  templateUrl: './font-size-picker.html',
  styleUrl: './font-size-picker.scss',
})
export class FontSizePicker {
  @Output() readonly fontSizeChange = new EventEmitter<FontSize>();

  handleFontSizeChange(size: FontSize): void {
    this.fontSizeChange.emit(size);
  }
}
